// import { useState, useEffect } from "react";
// import Container from "../../Assests/Images/Container.png";

// export default function ServiceBay() {
//   const [visible, setVisible] = useState(false);
//   const [isMobile, setIsMobile] = useState(
//     typeof window !== "undefined" ? window.innerWidth <= 768 : false
//   );

//   useEffect(() => {
//     const t = setTimeout(() => setVisible(true), 100);
//     return () => clearTimeout(t);
//   }, []);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Sora:wght@700;800&family=DM+Sans:wght@400;500&display=swap');
//         * { box-sizing: border-box; margin: 0; padding: 0; }
//       `}</style>

//       <div style={{
//         background: "#FAFAFA",
//         fontFamily: "'Inter var'",
//         padding: isMobile ? "48px 16px 60px" : "70px 24px 80px",
//         minHeight: isMobile ? "auto" : "100vh",
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//       }}>

//         {/* Header */}
//         <div style={{
//           textAlign: "center",
//           marginBottom: "48px",
//           opacity: visible ? 1 : 0,
//           transform: visible ? "translateY(0)" : "translateY(24px)",
//           transition: "opacity 0.7s ease, transform 0.7s ease",
//           marginTop: "20px",
//         }}>
//           <h1 style={{
//             fontSize: "clamp(28px, 5vw, 52px)",
//             fontFamily: "'Inter var'",
//             fontWeight: "500",
//             color: "#111",
//             letterSpacing: "-1.5px",
//             lineHeight: "1.12",
//             marginBottom: "16px",
//           }}>
//             The World Is Your Service Bay.
//           </h1>
//           <p style={{
//             fontSize: "15px",
//             color: "#888",
//             lineHeight: "1.9",
//             maxWidth: "360px",
//             margin: "0 auto",
//             marginTop: isMobile ? "20px" : "40px",
//           }}>
//             Our network of mobile mechanics is always just around the corner.
//           </p>
//         </div>

//         {/* 
//           ── MAP IMAGE ──
//           Apni Figma se exported image ka path yahan dalo:
//           src="./your-map-image.png"  ya  src={mapImage}
//         */}
//         <div style={{
//           width: "100%",
//           maxWidth: "1060px",
//           borderRadius: "24px",
//           overflow: "hidden",
//           opacity: visible ? 1 : 0,
//           transform: visible ? "translateY(0)" : "translateY(20px)",
//           transition: "opacity 0.7s ease 0.2s, transform 0.7s ease 0.2s",
//         }}>
//           <img
//             src={Container}
//             alt="Service map"
//             style={{
//               width: "100%",
//               display: "block",
//               borderRadius: isMobile ? "16px" : "24px",
//             }}
//           />
//         </div>

//       </div>
//     </>
//   );
// }
import { useState, useEffect } from "react";
import ContainerImg from "../../Assests/Images/Container.png";

export default function ServiceBay() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 991);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section className="service-bay-section">
      {/* Gradient Grid Lines (Stoke) */}
      <div className="grid-lines">
        <div className="v-line l-left"></div>
        <div className="v-line l-right"></div>
      </div>

      <div className="content-wrapper">
        {/* Header Section */}
        <div className="header-box">
          <h1 className="main-heading">
            The World Is Your Service Bay.
          </h1>
          <p className="sub-heading">
            Our network of mobile mechanics is always just around the corner.
          </p>
        </div>

        {/* Map Container Image */}
        <div className="map-wrapper">
          <img
            src={ContainerImg}
            alt="Service Map Mockup"
            className="map-image"
          />
          {/* Subtle shadow overlay to match the premium look */}
          <div className="map-shadow"></div>
        </div>
      </div>

      <style dangerouslySetInnerHTML={{ __html: `
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .service-bay-section {
          background-color: #ffffff;
          padding: 20px 20px;
          position: relative;
          font-family: 'Inter', sans-serif;
          overflow: hidden;
          display: flex;
          justify-content: center;
        }

        .content-wrapper {
          width: 100%;
          max-width: 1200px;
          text-align: center;
          position: relative;
          z-index: 2;
        }

        /* --- Gradient Grid Lines --- */
        .grid-lines {
          position: absolute;
          inset: 0;
          pointer-events: none;
          z-index: 1;
        }
        .v-line {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 1px;
          
        }
        .l-left { left: 12%; }
        .l-right { right: 12%; }

        /* --- Header Styles --- */
        .header-box {
          margin-bottom: 60px;
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .main-heading {
          font-size: clamp(30px, 4.2vw, 43px);
          font-weight: 600;
          color: #0F172A;
          letter-spacing: -0.03em;
          line-height: 1.1;
          margin-bottom: 24px;
        }
        .sub-heading {
          font-size: 16px;
          color: #64748B;
          max-width: 380px;
          line-height: 1.6;
        }

        /* --- Map Image Styles --- */
        .map-wrapper {
          position: relative;
          width: 100%;
          border-radius: 24px;
          
          overflow: hidden;
          
        }
        .map-image {
          width: 100%;
          height: auto;
          display: block;
          /* Agar image ka background pure white nahi hai toh blend mode help karega */
          mix-blend-mode: multiply; 
        }
        .map-shadow {
          position: absolute;
          inset: 0;
          box-shadow: inset 0 0 40px rgba(255,255,255,1);
          pointer-events: none;
        }

        /* --- Mobile Responsiveness --- */
        @media (max-width: 991px) {
          .service-bay-section {
            padding: 20px 16px;
          }
          .l-left, .l-right {
            display: none; /* Mobile par clean look ke liye lines hide kar di hain */
          }
          .main-heading {
            font-size: 34px;
          }
          .map-wrapper {
            border-radius: 16px;
          }
        }
      `}} />
    </section>
  );
}